<template>
  <div class="trainenter">
    <el-steps :active="active" align-center>
      <el-step
        :title="item.title"
        v-for="item in stepData"
        :key="item.index"
      ></el-step>
    </el-steps>
    <el-row class="active0" v-show="active === 0">
      <Login @pactive='Active' />
    </el-row>
    <el-row class="active1" v-show="active === 1">
      <Perfect @twoactive='Active' />
    </el-row>
    <el-row style="margin-top:100px;" class="active2" v-show="active === 2">
      <el-button type="success" icon="el-icon-check" circle></el-button>
      <p class="success">您已提交申请成功，请耐心等待我们的消息！</p>
      <p class="success2">申请到正式开通预计需要1-3个工作日</p>
      <el-button type="primary" @click="returnHome">返回首页</el-button>
    </el-row>
  </div>
</template>
<script>
import Login from "./Login";
import Perfect from "./perfect";
export default {
  name: "trainenter",
  data() {
    return {
      active: 0, 
      stepData: [
        { index: 0, title: "建立账户" },
        { index: 1, title: "基本资料" },
        { index: 2, title: "提交成功" }
      ],
      nextTile: "下一步"
    };
  },
  computed: {},
  methods: {
    Active(num){
      this.active = num
    },
    stepClick(val) {
      var _that = this;
      _that.active = val;
    },
    nextClick() {
      var _that = this;
      if (_that.active < 3) {
        _that.active++;
      } else {
        _that.active = 0;
      }
    },
    // 提交审核之后返回首页
    returnHome() {
      this.$router.push("/");
    }
  },
  created() {},
  components: {
    Login,
    Perfect
  }
};
</script>
<style scoped>
.trainenter {
  width: 100%;

  margin-top: 100px;
}
el-steps {
  width: 80%;
  margin: 0 auto;
}
.success {
  font-size: 24px;
}
.success2 {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/trainEnter.vue